export default __webpack_public_path__ + "static/logo_bunner-35ae0e30d511e0514171fc55c1fe948f.svg";